// src/contexts/FriendRequestsContext.js
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import friendshipService from '../services/friendshipService';

const FriendRequestsContext = createContext(undefined);

export const FriendRequestsProvider = ({ children }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);

    const unsubscribe = friendshipService.subscribeFriendRequests((list) => {
      if (!isMounted) {
        return;
      }
      setRequests(list);
      setLoading(false);
    });

    return () => {
      isMounted = false;
      unsubscribe?.();
    };
  }, []);

  const value = useMemo(
    () => ({
      requests,
      loading,
      count: requests.length,
      hasRequests: requests.length > 0,
    }),
    [requests, loading]
  );

  return (
    <FriendRequestsContext.Provider value={value}>
      {children}
    </FriendRequestsContext.Provider>
  );
};

export const useFriendRequestsContext = () => {
  const context = useContext(FriendRequestsContext);
  if (context === undefined) {
    throw new Error(
      'useFriendRequestsContext must be used within a FriendRequestsProvider'
    );
  }
  return context;
};

